/**
 * Block metadata registry — ported from ThemeMaker's
 * {@code lms-portal/src/lib/platform/blockMetadata.ts}.
 *
 * <p>Per-block-type metadata the renderer consults to make layout
 * decisions. Today owns one flag — {@code bleedsUnderHeader} — but the
 * shape is designed to absorb more without one-off lookups.
 *
 * <h3>Source of truth</h3>
 * Long-term, this metadata lives on {@code BlockDefinition} rows in
 * the registry (backend). The portal would fetch them once per
 * request and build this map dynamically. Today ships the FALLBACK
 * form: a hardcoded set, populated from the same blocks marked
 * {@code bleedsUnderHeader: true} in {@code seed/registry/blocks/}.
 * Migrating to a fetched + cached map later is a no-caller-change.
 */

/**
 * Block types whose first-on-page rendering should bleed under a
 * floating overlay header (cinematic-immersive style with
 * {@code header.overlay: true}). When the first block on the page has
 * this flag, the shell suppresses its top padding and the block fills
 * the viewport edge-to-edge under the header.
 */
const BLEEDS_UNDER_HEADER: ReadonlySet<string> = new Set([
  'HeroVideo',
  'HeroVideoBackground',
  'HeroCinematic',
  'HeroSpotlight',
  'HeroSpotlightCards',
  'HeroSlider',
  'HeroEditorial',
  'WildTvHero',
]);

/**
 * Returns true when the named block type is designed to bleed under a
 * floating overlay header. Returns false for unknown types — safe
 * default; un-flagged blocks render normally with the header
 * reserving top space.
 */
export function blockBleedsUnderHeader(blockType: string | undefined | null): boolean {
  if (!blockType) return false;
  return BLEEDS_UNDER_HEADER.has(blockType);
}
